import React from 'react'
import styled from 'styled-components'
import themeColors from '@layers-frontend/commons/styles/themeColors'
import { StyledTooltip } from './StyledTooltip'

// The outline pill of the filter row: a mint contour, filled mint with deep navy icons under the pointer.
const Wrapper = styled.div`
  display: flex;
  direction: row;
  align-items: center;
  height: 34px;
  padding: 0 12px;
  border: 1px solid ${themeColors.mintColor};
  border-radius: 999px;
  gap: 5px;
  cursor: pointer;
  transition: background-color 0.15s;
  i {
    transition: color 0.15s;
  }
  &:hover {
    background-color: ${themeColors.mintColor};
  }
  &:hover i {
    color: ${themeColors.deepblueColor3};
  }
`
const MainIcon = styled.i`
  color: ${themeColors.mintColor};
  font-size: 20px;
`
const DirectionIcon = styled.i`
  color: ${themeColors.mintColor};
  font-size: 24px;
`

export const SortButton = ({ mainIcon, onClick, direction, tooltipTitle }) => {
  return (
    <StyledTooltip title={tooltipTitle} placement="left">
      <Wrapper onClick={onClick}>
        <DirectionIcon className={direction === 'asc' ? 'fas fa-long-arrow-alt-up' : 'fas fa-long-arrow-alt-down'} />
        <MainIcon className={mainIcon} />
      </Wrapper>
    </StyledTooltip>
  )
}
